import {Navigate, useNavigate, useParams, useSearchParams} from "react-router-dom";
import PLATFORMS from "../../tools/defaults/Platforms";
import {useEffect} from "react";

const AccessError = () => {
    const {id, service} = useParams();
    const returnUrl = sessionStorage.getItem('return_url');
    const ticketUuid = sessionStorage.getItem('ticket_uuid');
    const postToken = sessionStorage.getItem('post_token');
    const hasPostAddon = sessionStorage.getItem('has_post_addon')
    const hasUserAddon = sessionStorage.getItem('has_user_addon')


    function toQueryParams(obj) {
        return Object.keys(obj)
            .filter(key => obj[key] !== null && obj[key] !== undefined) // Exclude null and undefined
            .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
            .join('&');
    }

    const handleRedirectUrl = () => {
        if (id === PLATFORMS.DIVAR.ID) {
            const params = {
                "post_token": postToken ? postToken : null,
                "return_url": returnUrl ? returnUrl : null,
                "ticket_uuid": (ticketUuid && !ticketUuid.startsWith('vm_')) ? ticketUuid : null,
                "has_post_addon": hasPostAddon ? hasPostAddon : null,
                "has_user_addon": hasUserAddon ? hasUserAddon : null,
            }
            const queryParams = toQueryParams(params);

            return `/auth/start/${id}/${service}?${queryParams}`
        } else {
            return '/failed'
        }
    }
    return <Navigate to={handleRedirectUrl()}/>
}
export default AccessError;